/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Ask_ThemeInputs */



/**
* | output |
* | --- |
* | "Last question: light or dark? Switch it and the whole page follows. You can change this any time from your account menu." |
*
* @param {Onboarding_Ask_ThemeInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const onboarding_ask_theme = /** @type {((inputs?: Onboarding_Ask_ThemeInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Ask_ThemeInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Letzte Frage: hell oder dunkel? Schalte um, die ganze Seite folgt. Du kannst das jederzeit in deinem Kontomenü ändern.")
	return /** @type {LocalizedString} */ ("Last question: light or dark? Switch it and the whole page follows. You can change this any time from your account menu.")
});